import { Text } from "@radix-ui/themes";
import { memo } from "react";
import { HoverDetailsButton } from "./hover-details-button";
import { BaseCellProps } from "../lib/types";

const RejectionReasonCellComponent = ({
  value,
  onDetailsClick,
}: BaseCellProps) => {
  return (
    <>
      <Text size="1" color="gray" className="line-clamp-2 min-w-20">
        {value || "-"}
      </Text>
      <HoverDetailsButton onClick={onDetailsClick} />
    </>
  );
};

export const RejectionReasonCell = memo(RejectionReasonCellComponent);
